import { useUserContext } from "@repo/baseCloud";
import { FC } from "react";

import { useSettingsApi } from "../../../api/settingsApi";
import { useAssociationsInfoContext, useLocationContext } from "../../../contexts/editableItemContext";
import { Branch } from "./branch";
import style from "./style.module.scss";
import { Props } from "./types";

export const Branches: FC<Props> = ({ locationMarketer, readOnly }) => {
	const { useSettingsQuery } = useSettingsApi();
	const { locationId } = useLocationContext();
	const { user } = useUserContext();
	const { data: settings } = useSettingsQuery(user?.userId, locationId);
	const { limitMarketerAssociations } = settings ?? {};
	const { filters } = useAssociationsInfoContext();

	const { marketerId, marketerEnabled, branches } = locationMarketer;
	const { stateId, name } = filters;
	const nameFilter = name?.trim()?.toLowerCase();

	return (
		<div className={style.list}>
			{branches
				.filter(({ branchStateId, branchName }) => {
					const stateMatches = !stateId || branchStateId == stateId;
					const nameMatches = !nameFilter || branchName.toLowerCase().includes(nameFilter);
					return stateMatches && nameMatches;
				})
				.map((b) => (
					<Branch
						key={b.branchId}
						branch={b}
						marketerId={marketerId}
						marketerEnabled={marketerEnabled}
						limitMarketerAssociations={limitMarketerAssociations}
						readOnly={readOnly}
					/>
				))}
		</div>
	);
};
